// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"1781f8de","667":"5545ba99"}[chunkId] + ".chunk.js";
};